import br3_1 from "./br3-1.jpg";
import br3_2 from "./br3-2.jpg";
import br3_3 from "./br3-3.jpg";
import br3_4 from "./br3-4.jpg";
import br3_5 from "./br3-5.jpg";
import br3_6 from "./br3-6.jpg";
import br3_7 from "./br3-7.jpg";
import br3_8 from "./br3-8.jpg";
import br3_9 from "./br3-9.jpg";
import br3_10 from "./br3-10.jpg";
import br3_11 from "./br3-11.jpg";
import br3_12 from "./br3-12.jpg";
import br3_13 from "./br3-13.jpg";
import br3_14 from "./br3-14.jpg";
import br3_15 from "./br3-15.jpg";
import br3_16 from "./br3-16.jpg";
import br3_17 from "./br3-17.jpg";
import br3_18 from "./br3-18.jpg";
import br3_19 from "./br3-19.jpg";
import br3_20 from "./br3-20.jpg";
import br3_21 from "./br3-21.jpg";
import br3_22 from "./br3-22.jpg";
import br3_23 from "./br3-23.jpg";
import br3_24 from "./br3-24.jpg";
import br3_25 from "./br3-25.jpg";
import br3_26 from "./br3-26.jpg";
import br3_27 from "./br3-27.jpg";
import br3_28 from "./br3-28.jpg";
import br3_29 from "./br3-29.jpg";
import br3_30 from "./br3-30.jpg";
import br3_31 from "./br3-31.jpg";
import br3_32 from "./br3-32.jpg";
import br3_33 from "./br3-33.jpg";
import br3_34 from "./br3-34.jpg";
import br3Fp1np3d from "./br3-fp-1np-3d.jpg";
import br3Fp1np2d from "./br3-fp-1np-2d.jpg";
import br3Fp2np3d from "./br3-fp-2np-3d.jpg";
import br3Fp2np2d from "./br3-fp-2np-2d.jpg";
import br3Fp1kk3d from "./br3-fp-1kk-3d.jpg";
import br3Fp1kk2d from "./br3-fp-1kk-2d.jpg";

export const brnik3Images = [
  br3_1, br3_2, br3_3, br3_4, br3_5, br3_6, br3_7, br3_8, br3_9, br3_10,
  br3_11, br3_12, br3_13, br3_14, br3_15, br3_16, br3_17, br3_18, br3_19, br3_20,
  br3_21, br3_22, br3_23, br3_24, br3_25, br3_26, br3_27, br3_28, br3_29, br3_30,
  br3_31, br3_32, br3_33, br3_34,
];

export const brnik3FloorPlans = [
  { image: br3Fp1np3d, label: "1. NP – 3D" },
  { image: br3Fp1np2d, label: "1. NP – 2D" },
  { image: br3Fp2np3d, label: "2. NP – 3D" },
  { image: br3Fp2np2d, label: "2. NP – 2D" },
  { image: br3Fp1kk3d, label: "1+kk – 3D" },
  { image: br3Fp1kk2d, label: "1+kk – 2D" },
];
